module.exports = __webpack_public_path__ + "img/hood_work.f2ac4555.png";